// SPDX-License-Identifier: AGPL-3.0-or-later
import * as ChannelCommands from '@app/features/channel/commands/ChannelCommands';
import Channels from '@app/features/channel/state/Channels';
import * as ModalCommands from '@app/features/ui/commands/ModalCommands';
import * as ToastCommands from '@app/features/ui/commands/ToastCommands';
import {ChannelTypes} from '@app/vendor/constants/ChannelConstants';
export interface ChannelDeleteModalProps {
	channelId: string;
}
export async function deleteChannel(channelId: string): Promise<void> {
	const channel = Channels.getChannel(channelId);
	if (!channel) return;
	await ChannelCommands.remove(channelId);
	ModalCommands.popAll();
	ToastCommands.createToast({
		type: 'success',
		children: channel.type === ChannelTypes.GUILD_CATEGORY ? 'Category deleted' : 'Channel deleted',
	});
}
export function getChannelDeleteInfo(channelId: string) {
	const channel = Channels.getChannel(channelId);
	if (!channel) return null;
	const isCategory = channel.type === ChannelTypes.GUILD_CATEGORY;
	const title = isCategory ? 'Delete category' : 'Delete channel';
	const confirmText = isCategory ? 'Delete category' : 'Delete channel';
	const successMessage = isCategory ? 'Category deleted' : 'Channel deleted';
	return {
		channel,
		isCategory,
		title,
		confirmText,
		successMessage,
	};
}
